export default __webpack_public_path__ + "static/media/thumbnail-learn.bfdb9cf5.jpg";